<template>
  <transition name="fadeA-transform" mode="out-in">
    <div id="phoneAEmail" @click="goFacebook" class="phoneA-email-icon">
      <img class="phoneA-email-img" src="https://mediakit.enabot.com/eboX/img/mobile/phone_ShoppingCart_icon.png" alt="">
      <div class="phoneA-email-text">
        Pre-Order
      </div>
    </div>
  </transition>
</template>


<script>

export default {
  data() {
    return {
      scroll:null
    }
  },
  mounted() {
    window.addEventListener('scroll', this.emailShow)
  },
  destroyed() {
    window.removeEventListener('scroll', this.emailShow)
  },
  methods: {
    goFacebook() {
      this.scrollToTop(0)
      // var timer = setInterval(function () {
      //   let osTop = document.documentElement.scrollTop || document.body.scrollTop;
      //   let ispeed = Math.floor(-osTop / 5);
      //   document.documentElement.scrollTop = document.body.scrollTop = osTop + ispeed;
      //   this.isTop = true;
      //   if (osTop === 0) { clearInterval(timer) }
      // }, 10);
      // const that = this
      // let timer = setInterval(() => {
      //   let ispeed = Math.floor(-that.scrollTop / 5)
      //   document.documentElement.scrollTop = document.body.scrollTop = that.scrollTop + ispeed
      //   if (that.scrollTop === 0) {
      //     clearInterval(timer)
      //   }
      // }, 16)
      // document.getElementById('app').scrollIntoView({ behavior: "smooth" });
      // window.scrollTo(0,0);
      // document.getElementById('app').remove('topBBBB')
      // document.getElementById('app').className = 'topAAAA'
      
      // document.getElementById('app').scrollIntoView({ behavior: "smooth" });
      // setTimeout(()=>{
        
      //   // document.getElementById('app').remove('topAAAA')
      //   document.getElementById('app').className = 'topBBBB';
      // },1000)
    //   var height = document.documentElement.scrollTop || document.body.scrollTop;
    // var t = setInterval(() => {
    //     height -= 50;
    //     if(height > 0) {
    //         window.scrollTo(0,height);
    //     }else {
    //         window.scrollTo(0,0);
    //         clearInterval(t);
    //     }
    // }, 10);
    },
    scrollToTop(position) {
      // 使用requestAnimationFrame，如果没有则使用setTimeOut
      if(!window.requestAnimationFrame) {
        window.requestAnimationFrame = function(callback) {
          return setTimeout(callback, 20)
        }
      }

      // 获取当前元素滚动的距离
      let scrollTopDistance = document.documentElement.scrollTop || document.body.scrollTop;

      function smoothScroll() {
        // 如果你要滚到顶部，那么position传过来的就是0，下面这个distance肯定就是负值。
        let distance = position - scrollTopDistance;
        // 每次滚动的距离要不一样，制造一个缓冲效果
        scrollTopDistance = scrollTopDistance + distance / 5;
        // 判断条件
        if(Math.abs(distance) < 1) {
          window.scrollTo(0, position);
        }else {
          window.scrollTo(0, scrollTopDistance);
          requestAnimationFrame(smoothScroll);
        }
      }
      smoothScroll();
    },
    emailShow() {
      let scrollTop = document.body.scrollTop || document.documentElement.scrollTop;
      if (scrollTop <= 400) {
        document.getElementById("phoneAEmail").style.display = 'none'
      } else {
        document.getElementById("phoneAEmail").style.display = 'flex'
      }
    }
  },
}
</script>

<style lang="scss">
.phoneA-email-icon {
  z-index: 999999;
  position: fixed;
  top: 18px;
  right: -2px;
  width: 132px;
  height: 45px;
  display: flex;
  justify-content: center;
  align-items: center;
  display: none;
  // opacity: 0;
  // transition: 1s linear 1s;
  // background-image: url('https://mediakit.enabot.com/eboX/img/mobile/phone_email_icon_bg.png');
  background: linear-gradient(to right, rgb(85, 112, 240), rgb(57, 136, 255));
  border-radius: 20px 0 0 20px;

  .phoneA-email-img {
    width: 36px;
    height: auto;
    margin-right: 5px;
    margin-left: 6px;
  }

  .phoneA-email-text {
    font-size: 12px;
    width: 64px;
    font-weight: bold;
    color: #FFFFFF;
    line-height: 13px;
    text-align: left;
  }
}

.phoneA-email-icon:active {
  transform: scale(0.98);
}</style>